import React, { useContext, useEffect, useRef, useState } from 'react';
import SessionContext from '../../../providers/session/sessionContext';
import { makeStyles } from '@material-ui/styles';
import theme from '../../../theme';
import { Button } from '@material-ui/core';
import { useTranslation } from 'tools/i18n';
import CampaignSVG from '../../../../public/images/campaigns/black-week-2024.svg';
import { ErrorContext } from '../../../providers/error';

const useStyles = makeStyles(() => ({
    couponCodeWrapper: {
        color: 'white',
        background: 'black',
        marginTop: 20,
        padding: 40,
        gridColumn: '1/3',
        borderRadius: 3,
        width: '100%',
    },
    couponCodeApply: {
        marginTop: 10,
        width: '100%',
        ...theme.button.purchase,
        fontSize: 13,
        color: '#000',
        backgroundColor: '#fff',
        textAlign: 'center',
        border: '1px solid white',
        '&:hover': {
            ...theme.button.purchaseHover,
            backgroundColor: 'transparent',
            color: '#fff'
        },
    },
    couponText: {
        margin: '20px 0',
        // whiteSpace: 'pre-line', // flip on if using newlines from translations
        '& ul': {
            padding: 0,
            listStylePosition: 'inside'
        }
    },
}));

export default function CampaignBlock({ product, prices }) {
    const session = useContext(SessionContext);
    const actions = session.actions;
    const {actions: errorActions} = useContext(ErrorContext);
    const classes = useStyles();
    const coupons = actions.getAppliedCouponCodes();
    const { t } = useTranslation(['campaigns'])
    const [saleIsOnGoing, setSaleIsOnGoing] = useState(false);
    const couponTriggers = [
        'PREACCESS',
        'FRIENDBF',
        'SMSBF',
    ];

    useEffect(() => {
        let inviteEnd = new Date('Dec 03, 2024 00:00:00');
        let now = new Date();

        if (now < inviteEnd) {
            setSaleIsOnGoing(true);
        } else {
            setSaleIsOnGoing(session.isSaleOngoing || hasActiveCoupons(coupons));
        }
    },[product.id, coupons]);

    function hasActiveCoupons(coupons) {
        const activeCoupons = coupons.filter((item) => couponTriggers.includes(item)).length > 0;
        return activeCoupons.length > 0
    }

    function triggerNewsletterPopup() {
        window.dispatchEvent(new CustomEvent('intro-popup'))
    }
    async function activateCoupon(code) {
        const result = await actions.applyCoupon(code)
        if (result.status !== 'missing-email') {
            errorActions.addError({
                type: 'success',
                messageKey: 'discount-code-success',
                messageData: {
                    code: code
                }
            });
        }
    }

    function isRegularPrice() {
        if (prices.listPrice) {
            return false;
        }

        if (product.manufacturer?.name === 'Slim Aarons') {
            return false;
        }

        if (product.productNumber.indexOf('8888-') >= 0) {
            return false;
        }

        return true;
    }

    function hasAllowedProductStreams() {
        const allowedStreamIds = '';
        return product.streamIds.filter((id) => allowedStreamIds.includes(id)).length > 0;
    }

    function isOutlet() {
        return product?.categoryIds?.includes('57ada96765bb54639310048c787ff6e8')
    }

    function isChristmasCategory() {
        return product?.categoryIds?.includes('9ae2fdbdcead5e06a8ee2513f886342c')
    }

    // RETURNS

    if (!saleIsOnGoing || isRegularPrice() || !actions.isSalesChannelNordic()) {
        //DONT SHOW THESE
        return <></>;
    }

    if (hasActiveCoupons(coupons)) {
        //ACTIVE COUPON
        return <>
            <div className={classes.couponCodeWrapper}>
                <div>
                    <CampaignSVG/>
                </div>
                <p className={classes.couponText}>
                    {t('campaign-block-text-with-access')}
                </p>
                <Button className={classes.couponCodeApply} href={'/black-week'}>
                    {t('campaign-block-button')}
                </Button>
            </div>
        </>
    }

    if (isOutlet()) {
        //OUTLET WITH CODE
        return <>
            <div className={classes.couponCodeWrapper}>
                <div>
                    <CampaignSVG/>
                </div>
                <p className={classes.couponText}>
                    {t('campaign-block-text-outlet')}
                </p>
                <Button className={classes.couponCodeApply} onClick={ ()=>{ activateCoupon('BWOUT10')} }>
                    {t('campaign-block-button-outlet')}
                </Button>
            </div>
        </>
    }

    if (isChristmasCategory()) {
        //CHRISTMAS CAMPAIGN
        return <>
            <div className={classes.couponCodeWrapper}>
                <div>
                    <CampaignSVG/>
                </div>
                <p className={classes.couponText}>
                    {t('campaign-block-text-xmas')}
                </p>
                <Button className={classes.couponCodeApply} href={'/super-deals#christmas-deals'}>
                    {t('campaign-block-button-xmas')}
                </Button>
            </div>
        </>
    }

    if (saleIsOnGoing) {
        //REGULAR SALE
        return <>
            <div className={classes.couponCodeWrapper}>
                <div>
                    <CampaignSVG/>
                </div>
                <p className={classes.couponText}>
                    {t('campaign-block-text-with-access')}
                </p>
                <Button className={classes.couponCodeApply} href={'/black-week'}>
                    {t('campaign-block-button')}
                </Button>
            </div>
        </>
    }

    // ANYTHING ELSE
    return <></>;
}
